<template>
  <section class="page-content--bgf7">
    <section class="statistic statistic2">
      <div class="container">
        <v-card
          class="m-b-40"
          :loading="loading"
        >
          <h1 class="h3 m-l-20 p-t-20">
            <v-btn
              text
              icon
              class="m-0"
              @click="$router.back()"
            >
              <i class="zmdi zmdi-long-arrow-left" />
            </v-btn>
            Edit "{{ asset.name }}"
          </h1>
          <div class="row">
            <div class="col-md-3">
              <v-img
                width="300"
                height="450"
                contain
                class="grey darken-4 m-b-20"
                :src="asset.posterId ? '/api/v1/upload/' + asset.posterId : defaultPoster"
              />
              <v-file-input
                v-model="posterFile"
                class="pointer"
                placeholder="Upload a new poster (JPEG, PNG)"
                truncate-length="15"
                label="File input"
                style="width: 300px;"
                show-size
                accept="image/png, image/jpeg"
                prepend-icon="mdi-paperclip"
                @change="fileUpload('poster', posterFile)"
              />
            </div>
            <div class="col-md-9">
              <div
                v-if="loading"
                class="el-loading-mask"
              >
                <div class="el-loading-spinner">
                  <svg
                    viewBox="25 25 50 50"
                    class="circular"
                  >
                    <circle
                      cx="50"
                      cy="50"
                      r="20"
                      fill="none"
                      class="path"
                    />
                  </svg>
                </div>
              </div>
              <v-card-text class="p-t-0 p-b-20">
                <table class="asset-edit">
                  <tr>
                    <td>Type</td>
                    <td>
                      <div
                        class="p-b-20"
                        style="max-width: 200px;"
                      >
                        <v-select
                          v-model="asset.type"
                          outlined
                          background-color="blue-grey lighten-5"
                          dense
                          hide-details
                          :items="types"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr v-if="asset.vodType === 'episode'">
                    <td class="p-t-25">
                      TV Series <span class="asterisk">*</span>
                    </td>
                    <td>
                      <div class="p-b-20">
                        <v-select
                          v-model="asset.seriesId"
                          :items="series"
                          item-text="name"
                          item-value="id"
                          required
                        >
                          <template v-slot:append-outer>
                            <v-btn
                              class="m-l-20"
                              @click="seriesDialog = true"
                            >
                              <v-icon left>
                                mdi-plus
                              </v-icon>
                              Add TV Series
                            </v-btn>
                          </template>
                        </v-select>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="asset.vodType === 'episode'">
                    <td>Episode Index*</td>
                    <td>
                      <v-text-field
                        v-model="asset.episodeIndex"
                        type="number"
                        :rules="rules.episodeIndex"
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Title <span class="asterisk">*</span></td>
                    <td>
                      <v-text-field
                        v-model="asset.name"
                        :counter="255"
                        :rules="rules.nameRules"
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="vertical-align: top !important;"
                      class="p-t-20"
                    >
                      Description
                    </td>
                    <td>
                      <v-textarea
                        v-model="asset.description"
                        append-icon="mdi-comment-text"
                        rows="1"
                        auto-grow
                        counter
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Categories
                    </td>
                    <td>
                      <v-autocomplete
                        v-model="asset.categories"
                        :items="categories"
                        item-text="name"
                        return-object
                        small-chips
                        multiple
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Genres
                    </td>
                    <td>
                      <v-autocomplete
                        v-model="asset.genres"
                        :items="genres"
                        return-object
                        small-chips
                        item-text="name"
                        multiple
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Tags
                    </td>
                    <td>
                      <v-combobox
                        v-model="asset.tags"
                        :items="tags"
                        :search-input.sync="tagSearch"
                        hide-selected
                        multiple
                        persistent-hint
                        small-chips
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                No results matching
                                "<strong>{{ tagSearch }}</strong>".
                                Press <kbd>enter</kbd> to create a new one
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-combobox>
                    </td>
                  </tr>
                  <tr v-if="asset.vodType === 'vod' || asset.vodType === 'episode'">
                    <td>Running time</td>
                    <td>
                      <div
                        class="ma-0 pa-0"
                        style="max-width: 200px;"
                      >
                        <v-text-field
                          :value="moment.utc(asset.duration * 1000).format('HH:mm:ss')"
                          disabled
                        />
                      </div>
                    </td>
                  </tr>
                </table>
              </v-card-text>
              <v-row
                v-if="asset.vodType === 'package'"
                class="p-r-30 p-t-25 p-l-20"
                no-gutters
              >
                <v-col md="6">
                  <h2 class="h5">
                    <i class="fa fa-list p-r-10" />Content
                    <v-btn
                      icon
                      class="m-l-5"
                      style="margin-bottom: 3px"
                      color="primary darken-1"
                      @click="openSelectVODsDialog()"
                    >
                      <v-icon size="20">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </h2>
                </v-col>
                <v-col
                  md="4"
                  offset-md="2"
                  class="text-right"
                >
                  <h2 class="text-overline">
                    <i class="fa fa-list p-r-10" />
                    Total duration: {{ moment.utc(totalDuration * 1000).format('HH:mm:ss') }}
                  </h2>
                </v-col>
              </v-row>
              <v-row
                v-if="asset.vodType === 'package'"
                class="p-r-30 p-l-20"
                no-gutters
              >
                <v-col md="12">
                  <v-row
                    v-if="asset.assets.length === 0"
                    align="center"
                    class="spacer"
                    no-gutters
                  >
                    <v-col
                      cols="12"
                      md="12"
                      class="text-center pa-5"
                      style="border: 1px solid #eee;"
                    >
                      Select movies or series and then you can rearrange
                      your package content by dragging and dropping items
                    </v-col>
                  </v-row>
                  <v-expansion-panels
                    popout
                    class="m-r-30"
                  >
                    <draggable
                      v-model="asset.assets"
                      v-bind="{animation: 200}"
                      class="dragg-list"
                    >
                      <v-expansion-panel
                        v-for="(a, i) in asset.assets"
                        :key="a.id"
                        hide-actions
                      >
                        <v-expansion-panel-header>
                          <v-row
                            align="center"
                            class="spacer"
                            no-gutters
                          >
                            <v-col
                              cols="4"
                              sm="2"
                              md="1"
                            >
                              <img
                                height="30"
                                width="30"
                                :src="a.poster ? a.poster + '?img.contain=30x30' : defaultPoster"
                                alt="Poster"
                              >
                            </v-col>

                            <v-col
                              class="hidden-xs-only"
                              sm="5"
                              md="7"
                            >
                              {{ a.name }}
                              <span
                                v-if="a.year"
                                class="grey--text"
                              >
                                &nbsp;({{ a.year }})
                              </span>
                            </v-col>
                            <v-col
                              cols="4"
                              sm="2"
                              md="2"
                            >
                              {{ moment.utc(a.duration * 1000).format('HH:mm:ss') }}
                            </v-col>
                            <v-col
                              class="text-center"
                              cols="4"
                              sm="2"
                              md="2"
                            >
                              <v-chip
                                color="blue lighten-4"
                              >
                                {{ i+1 }}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-divider />
                          <v-card-text>
                            {{ a.shortDescription || 'no description' }}<br>
                            <a
                              v-if="a.streamURL"
                              href="#"
                              @click.prevent="openPlayer(a.streamURL)"
                            >
                              <i class="fas fa-play p-r-5" />
                              Play
                            </a>
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </draggable>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-card-actions class="m-r-20 p-b-20">
            <v-spacer />
            <v-btn
              depressed
              :loading="isSaving"
              :disabled="!isFormValid || isSaving"
              color="success"
              @click="save()"
            >
              <v-icon left>
                fas fa-save
              </v-icon>
              {{ creating ? 'Create' : 'Save' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </section>

    <!-- Add Series -->
    <v-dialog
      v-model="seriesDialog"
      max-width="500"
      persistent
    >
      <v-card class="pa-3">
        <v-card-title class="text-h5">
          Add TV Series
        </v-card-title>
        <v-card-text>
          <div class="row">
            <div class="col-12">
              <v-text-field
                v-model="series.name"
                label="Name*"
                :counter="255"
                :rules="rules.nameRules"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <v-textarea
                v-model="series.shortDescription"
                label="Description"
                counter
                auto-grow
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="seriesDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="success"
            @click="addSeries()"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Select VODs Dialog -->
    <v-dialog
      v-model="selectVODsDialog"
      max-width="1000"
    >
      <v-card>
        <v-card-title class="text-h5">
          Select VOD
        </v-card-title>
        <p class="p-l-25">
          There are only assets in status Ready shown here
        </p>
        <v-card-title class="m-t-0 p-t-0">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          />
        </v-card-title>
        <v-data-table
          v-model="packageSelected"
          :headers="assetHeaders"
          :items="assets"
          :search="search"
          :items-per-page="7"
          :page.sync="page"
          hide-default-footer
          show-select
          class="elevation-1 asset-table"
          @page-count="pageCount = $event"
        >
          <template v-slot:item.poster="{ item }">
            <img
              width="30"
              height="30"
              :src="item.poster ? item.poster + '?img.contain=30x30' : defaultPoster"
              alt=""
            >
          </template>
          <template v-slot:item.vodType="{ item }">
            <v-chip
              class="chip_in_table"
              label
              small
            >
              {{ item.vodType }}
            </v-chip>
          </template>
          <template v-slot:item.duration="{ item }">
            {{ moment.utc(item.duration * 1000).format('HH:mm:ss') }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ moment(item.createdAt).utc().format('MMM D YYYY') }}
          </template>
        </v-data-table>
        <div class="text-center pt-3 pb-3">
          <v-pagination
            v-if="pageCount > 1"
            v-model="page"
            :length="pageCount"
          />
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="selectVODsDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            text
            color="success"
            @click="selectVODs"
          >
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      :persistent="false"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="p-l-20 p-r-20">
                {{ asset.name }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </section>
</template>

<script>
  import Vue from 'vue'
  import draggable from 'vuedraggable'
  import {
    assetToJsonAPI,
    processAsset,
    processTag,
    processGenre,
    processCategory,
  } from '@/store/converters'

  export default {
    components: {
      draggable,
    },
    data () {
      return {
        posterFile: null,
        tags: [],
        tagMap: {},
        tagSearch: null,
        genres: [],
        categories: [],
        channel: {},
        creating: false,
        title: '',
        assets: [],
        packageSelected: [],
        selectVODsDialog: false,
        assetHeaders: [
          {
            text: '',
            filterable: false,
            sortable: false,
            value: 'poster',
          },
          {
            text: 'Name',
            value: 'name',
          },
          { text: 'Duration', value: 'duration' },
          {
            text: 'Type',
            value: 'vodType',
          },
          { text: 'Created', value: 'createdAt', align: 'start' },
        ],
        search: '',
        page: 1,
        pageCount: 0,
        file: null,
        asset: {
          name: '',
          vodType: '',
          assets: [],
        },
        isSaving: false,
        types: ['movie', 'ad'],
        series: [],
        seriesDialog: false,
        newSeries: {
          name: '',
          shortDescription: '',
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 255) || 'Name must be less than 255 characters',
          ],
          yearRules: [
            (v) => (v === '' || v > 1900) || 'Invalid year',
          ],
          shortDescriptionRules: [
            (v) => (v.length >= 0 && v.length <= 1024) || 'Short description must be less than 1024 characters',
          ],
          episodeIndex: [
            (v) => (v > 0) || 'Invalid index',
          ],
        },
        frameSrc: '',
        playerDialog: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      defaultPoster () {
        return '/images/poster2x3.jpg'
      },
      isFormValid () {
        if (!(this.asset.name.length >= 3 && this.asset.name.length <= 255)) {
          return false
        }
        if (this.asset.vodType === 'episode' && !this.asset.seriesId) {
          return false
        }
        if (this.asset.vodType === 'episode' && this.asset.episodeIndex <= 0) {
          return false
        }
        if (this.asset.vodType === 'package' && this.asset.assets.length === 0) {
          return false
        }
        return true
      },
      totalDuration () {
        let total = 0
        for (let i = 0; i < this.asset.assets.length; i += 1) {
          total += this.asset.assets[i].duration
        }
        return total
      },
    },
    created () {
      this.channel.id = this.$route.params.id
      if (this.$route.path.endsWith('package/new')) {
        this.getAssets()
        this.title = 'New Package'
        this.asset.vodType = 'package'
        this.creating = true
      } else {
        const assetId = this.$route.params.asset_id
        this.loadData(assetId)
      // this.getTVSeries();
      }
      this.setFrameSrc('')
    },
    methods: {
      loadData (assetId) {
        this.$store.commit('setPageLoader')

        const args = {
          id: assetId,
          $expand: 'tags,genres,categories,pictures',
        }
        const assetReq = this.$store.dispatch('getAssetById', args)

        const metaArgs = {
          'channel.id[eq]': this.channel.id,
        }
        const tagReq = this.$store.dispatch('tags', metaArgs)
        const genreReq = this.$store.dispatch('genres', metaArgs)
        const categoryReq = this.$store.dispatch('categories', metaArgs)

        return Promise.all([assetReq, tagReq, genreReq, categoryReq])
          .then((res) => {
            const asset = res[0]
            const processedAsset = processAsset(asset)
            const assetTags = []
            for (let i = 0; i < processedAsset.tags.length; i += 1) {
              const t = processedAsset.tags[i]
              assetTags.push(t.name)
            }
            processedAsset.tags = assetTags
            this.asset = processedAsset

            const tags = res[1]
            const processedTags = tags.map((t) => processTag(t))
            for (let i = 0; i < processedTags.length; i += 1) {
              const t = processedTags[i]
              this.tags.push(t.name)
              this.tagMap[t.name] = t.id
            }

            const genres = res[2]
            this.genres = genres.map((t) => processGenre(t))

            const categories = res[3]
            this.categories = categories.map((t) => processCategory(t))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({
              name: 'AssetListPage',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getTVSeries () {
        this.$store.commit('setPageLoader')
        const args = {
          limit: 1000,
          offset: 0,
          vod_type: 'series',
        }
        this.$store.dispatch('getAssets', args)
          .then((result) => {
            this.series = result.assets.map((a) => processAsset(a))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getAssets () {
        this.$store.commit('setPageLoader')
        const args = {
          vod_type: 'movie,series',
          status: 'transcoding,transcoded,in_rotation',
        }
        this.$store.dispatch('getAssets', args)
          .then((result) => {
            this.assets = result.assets.map((a) => processAsset(a))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      fileUpload (tag, fileObj) {
        if (!fileObj) return
        const file = new FormData()
        file.append('uploadfile', fileObj, fileObj.name)

        this.$store.dispatch('upload', file)
          .then((result) => {
            Vue.set(this.asset, tag, result.blob)
            Vue.set(this.asset, `${tag}Id`, result.id)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      save () {
        if (!this.isFormValid) return

        this.isSaving = true

        this.$store.commit('setPageLoader')

        const tags = []
        for (let i = 0; i < this.asset.tags.length; i += 1) {
          const t = this.asset.tags[i]
          // eslint-disable-next-line no-prototype-builtins
          if (this.tagMap.hasOwnProperty(t)) {
            tags.push({
              id: this.tagMap[t],
            })
          } else {
            tags.push({
              name: t,
            })
          }
        }
        this.asset.tags = tags

        const asset = assetToJsonAPI(this.asset)

        this.$store.dispatch('updateAsset', asset)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: `The ${this.asset.type} has been successfully updated`,
              timeout: 3000,
              color: 'success',
            })
            this.$router.push({
              name: 'AssetDetailPage',
              params: {
                asset_id: this.asset.id,
              },
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.isSaving = false
            this.$store.commit('resolvePageLoader')
          })
      },
      addSeries () {
      },
      openSelectVODsDialog () {
        this.selectVODsDialog = true
        if (this.asset.assets.length) {
          this.packageSelected = JSON.parse(JSON.stringify(this.asset.assets))
        }
      },
      selectVODs () {
        this.asset.assets = JSON.parse(JSON.stringify(this.packageSelected))
        this.selectVODsDialog = false
      },
      openPlayer (stream) {
        this.setFrameSrc(stream)
        this.playerDialog = true
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.setFrameSrc('')
      },
    },
  }
</script>

<style>
  .checkboxes.v-input .v-label {
    margin-bottom: 0 !important;
  }
  .radios .v-label {
    margin: 0 !important;
  }
  .added .v-input__slot {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .dragg-list {
    width: 100%;
  }
</style>
